import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { createRoadYears, iNameTokenPair } from '../roadinfo-editor/roadinfo-editor.component';

interface iRoadInputValue{
  number: string;
  season: string;
  year: string;
}
@Component({
  selector: 'app-road-input',
  templateUrl: './road-input.component.html',
  styleUrls: ['./road-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RoadInputComponent,
      multi: true
    }
  ]
})
export class RoadInputComponent implements ControlValueAccessor {
  private onChange: Function = (date: string) => { };
  private onTouch: Function = () => { };
  @Output() newRoad:EventEmitter<iRoadInputValue> = new EventEmitter<iRoadInputValue>();
  @Output() valueChanged:EventEmitter<any> = new EventEmitter<any>();
  @Input() disabled: boolean = false;
  @Input()
  set value(value: iRoadInputValue) {
    this.writeValue(value);
    this.valueChanged.emit(value);
  }
  get value(): iRoadInputValue {
    if(this.invalid) return;
    return {
      number: this.roadNumber,
      season: this.roadSeason,
      year: this.roadYear
    };
  }
  get invalid(){
    let invalid = !(this.roadNumber && this.roadSeason && this.roadYear);
    return invalid;
  }
  public roadNumber:any;
  public roadSeason:any;
  public roadYear:any;
  public seasons:any[] = [ {
    name: 'HIVER',
    token: 'H'
  },{
    name:'ETE',
    token: 'G'
  }];
  public roadYears:any[] = createRoadYears();
  private resetTimeout:any;
  constructor() {

  }
  reset(){
    clearTimeout(this.resetTimeout);
    this.resetTimeout = setTimeout( ()=>{
      this.roadSeason ='';
      this.roadYear = '';
      this.roadNumber='';
      this.valueChanged.emit( this.value );
    },100);
  }
  emitNewRoad(){
    let value = this.value;
    if(!value) return;
    this.newRoad.emit( value );
    this.valueChanged.emit( value );
    this.reset();
  }
  handleSelectionChange(part:string,value:any){

    if(part == 'season'){
      this.roadSeason = value ;
    }
    if(part == 'year'){
      this.roadYear = value;
    }
    if(part == 'number'){
      this.roadNumber = value;
    }
    this.value = {number:this.roadNumber,season:this.roadSeason,year:this.roadYear};
    this.valueChanged.emit( this.value );
  }
  writeValue(value: iRoadInputValue): void {
    console.log('writeValue',value)
    if(this.disabled) return;
    this.onChange(value);
    this.valueChanged.emit( value);

  }
  // Save a reference to the change function passed to us by
  // the Angular form control
  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  // Save a reference to the touched function passed to us by
  // the Angular form control
  registerOnTouched(fn: Function): void {
    this.onTouch = fn;
  }

  // Allow the Angular form control to disable this input
  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;

  }

  ngOnInit() {}

}
